// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
// tslint:disable
export const environment = {
  production: false,
  gaKey:'UA-173468159-1',
  "product": {
    "id": "BlankPaper",
    "name": "Blank Paper",
    "version": "0.0.1",

    "imageUploadUrl": "https://blankpaper-qa.htmedia.in/cms-image-service-mt",
   // "baseUrl": "http://localhost:6060",
     "baseUrl": "https://blankpaper-qa.htmedia.in/cms-backend-service-mt",
     "listenerServiceUrl": "https://blankpaper-qa.htmedia.in/cms-listener-service",
     "utilUrl": "https://blankpaper-qa.htmedia.in/cms-util-service",
     "seoUrl" : "https://blankpaper-qa.htmedia.in/cms-seotools-integration-service",
    //"utilUrl": "http://localhost:6079",
    "socketUrl": "https://blankpaper-qa.htmedia.in/cms-backend-service-mt/socket",
    // "previewUrl": "http://10.136.172.12:7070",
    "previewUrl": "",
    "purgeUrl": "https://blankpaper-qa.htmedia.in/cms-backend-service-mt",
   // "wireImageDisplayUrl": "http://wire-image.htmedia.net/wire-images/",
    "wireImageDisplayUrl": "https://blankpaper-qa.htmedia.in/print-images/",
    "wireImageUrl": "http://10.136.172.211/print-images/",
   // "wireImageUrl": "http://wire-image.htmedia.net/wire-images/",
    "imageDeleteEndPoint" : "/api/image/delete",
    "imageUploadEndPoint" : "/api/image/upload",
    "imageUploadByUrlEndPoint" : "/api/image/upload/byurl",
    "videoUploadEndPoint" : "/api/video/upload",
    "imageCropByUrlEndPoint" : "/api/image/crop/byurl",
    "domainUrl": "https://blankpaper-qa.htmedia.in/common-config-service-mt",
    "tagsUrl": "https://blankpaper.htdigital.in/tag-api",
    "videoFeedUrl": "https://video-cms03.livehindustan.com/v1/videos",
    "seoAppUrl":"http://10.136.172.195:6077/",
    "podcastBaseUrl": "https://stg-smartcast.hindustantimes.com/wp-json/smartcast-api/v1",
    "videoCmsUrl": "https://blankpaper-qa.htmedia.in/cms-video-service",
    "notificationServiceUrl": "https://blankpaper-qa.htmedia.in/cms-backend-service-mt"
    // "videoFeedUrl": "http://10.2.18.116:9990/v1/videos"
  },
  "imageUrls": {
    "productLogoUrl": "assets/images/Blankpaper-logo.svg",
    "signInButtonImg": "assets/images/google-sign-in.svg",
    "router_link": "./workspace"
  },
  "domainBaseUrls": [
    {
      "id": "5d64f77fd0b4140e8b7e0dd1",
      "name": "DesiMartini",
      "baseUrl": "https://desimartini.com"
    },
    {
      "id": "63a8564c0118f51f159e8223",
      "name": "Live Hindustan",
      "baseUrl": "https://www.livehindustan.com"
    },
    {
      "id": "5e327b278d141d0525d32ad8",
      "name": "Smart 24",
      "baseUrl": "https://staging.smart24.com"
    },
    {
      "id": "5dbc042d23c0940529fc7892",
      "name": "Auto",
      "baseUrl": "http://stg-auto.hindustantimes.com"
    },
    {
      "id": "5ec3c0042ef42235fc2f175d",
      "name": "Mint Lounge",
      "baseUrl": "https://stg-mintlounge.livemint.com"
    },
    {
      "id": "5c1c93e66a2ec202bb648bbb",
      "name": "Hindustan Times",
      "baseUrl": "https://hindustantimes.com"
    },
    {
      "id": "5cd513942990d521f440136f",
      "name": "Hindi",
      "baseUrl": "https://hindi.hindustantimes.com"
    },
    {
      "id": "5df8a1b2e75f583b86696dbb",
      "name": "Tech",
      "baseUrl": "http://stg-tech.hindustantimes.com"
    },
    {
      "id": "5e79e6403ea335d2b751ac21",
      "name": "HT NEW",
      "baseUrl": "http://qa-www.hindustantimes.com"
    },
    {
      "id": "5d957dad88ac2b284f80fa33",
      "name": "Bangla",
      "baseUrl": "http://stg-bangla.hindustantimes.com"
    },
    {
      "id": "5aeab8eefc36f218b0e0866b",
      "name": "Live Mint",
      "baseUrl": "https://qa.livemint.com"
    }
  ],
  "views": {
    "view_id": "pageContainer",
    "subPages": [
      {
        "view_id": "login",
        "name": "Login",
        "subPages": [],
        "apiEndPoints": [{
          "api_id": "oauth_token",
          "url": "https://blankpaper-qa.htmedia.in/ht-authentication-service-mt/oauth/token"
        },
        {
          "api_id": "logout",
          "url": "/api/cms/logout"
        }]
      },
      {
        "view_id": "dashboard",
        "name": "Dashboard",
        "subPages": [
          {
            "view_id": "story_main",
            "name": "Story Container",
            "subPages": [],
            "apiEndPoints": [
              {
                "api_id": "save_story",
                "url": "/api/cms/story/"
              },
              {
                "api_id": "save_liveblog_story",
                "url": "/api/cms/story/liveblog/"
              },
              {
                "api_id": "get_story",
                "url": "/api/cms/story"
              },
              {
                "api_id": "lock_acquire",
                "url": "/api/cms/lock/acquire/article"
              },
              {
                "api_id": "lock_release",
                "url": "/api/cms/lock/release/article"
              },
              {
                "api_id": "versions",
                "url": "/api/cms/story/versions"
              },
              {
                "api_id": "element_versions",
                "url": "/api/cms/element/versions"
              },
              {
                "api_id": "element_by_id",
                "url": "/api/cms/element/get-all-by-ids/"
              },
              {
                "api_id": "unlock",
                "url": "/api/cms/unlock/article"
              },
              {
                "api_id": "secondaryLock",
                "url": "/api/cms/lock/acquire/secondaryLiveblogUser"
              },
              {
                "api_id": "publishLiveblogPost",
                "url": "/api/cms/story/push/"
              },
              {
                "api_id": "facebook_publish",
                "url": "/api/cms/notify/facebook"
              },
              {
                "api_id": "twitter_publish",
                "url": "/api/cms/notify/twitter"
              },
              {
                "api_id": "web_publish",
                "url": "/api/cms/notify/browser"
              },
              {
                "api_id": "app_publish",
                "url": "/api/cms/notify/mobile"
              },
              {
                "api_id": "url_generate",
                "url": "/api/cms/story/url/generate"
              },
              {
                "api_id": "keywords_generate",
                "url": "/api/cms/recosense/story"
              },
              {
                "api_id": "web_story_templates",
                "url": "/api/cms/web-story/templates"
              },
              {
                "api_id": "migration",
                "url": "/api/cms/story/migrate"
              }
            ]
          },
          {
            "view_id": "videoStory",
            "name": "Videos",
            "socketCodes": [],
            "subPages": [],
            "apiEndPoints": [
              {
                "api_id": "video_stories",
                "name": "Video Stories",
                "url": "/v1/videos"
              },
              {
                "api_id": "video_search",
                "name": "Video Search",
                "url": ""
              }
            ],
            "headers": [],
            "filters": [{
              "filter_id": "sitename",
              "name": "Source",
              "facet_name_meta": "sitename",
              "facet_name": "sitename",
              "type": "checkbox"
            }]
          },
          {
            "view_id": "slideVideoListing",
            "name": "Videos",
            "socketCodes": [],
            "subPages": [],
            "apiEndPoints": [
              {
                "api_id": "video_stories",
                "name": "Video Stories",
                "url": "/api/cms/elements"
              },
              {
                "api_id": "video_search",
                "name": "Video Search",
                "url": "/api/cms/elements"
              }
            ],
            "headers": [{
              "header_id": "video",
              "name": "Video",
              "model_id": "slide",
              "class": "video",
              "type": "video",
              "sortByValue": "lastModifiedDate",
              "byField":"type"
            }],
            "filters": []
          },
          {
            "view_id": "videoServiceStory",
            "list_router": "/dash/story",
            "name": "Video Service Stories",
            "socketCodes": [1,2,7],
            "apiEndPoints": [
              {
                "api_id": "all_story",
                "name": "All Stories",
                "url": "/api/cms/stories"
              },
              {
                "api_id": "search_story",
                "name": "Stories",
                "url": "/api/cms/search/story"
              },
              {
                "api_id": "search_inPage",
                "name": "Stories",
                "url": "/api/cms/search/all"
              },
              {
                "api_id": "dashboard_meta",
                "name": "Dashboard Meta",
                "url": "/api/cms/dashboard/meta"
              },
              {
                "api_id": "story_suggestions",
                "name": "Dashboard Story Suggestions",
                "url": "/api/cms/story/suggestions"
              },
              {
                "api_id": "get_story_byids",
                "url": "/api/cms/story/get-all-by-ids/"
              },
              {
                "api_id": "unlock",
                "url": "/api/cms/unlock/article"
              }
            ],
            "headers": [
              {
                "header_id": "headline",
                "name": "Headline",
                "model_id": "title",
                "class": "headline spImg",
                "type": "text",
                "conditionOn": 1
              },
              {
                "header_id": "format",
                "name": "Type",
                "model_id": "type",
                "class": "format",
                "type": "text",
                "showIcon": true
              },
              {
                "header_id": "status",
                "name": "Status",
                "model_id": "metadata.status",
                "class": "status",
                "type": "status",
                "colorCondition": true
              },
              {
                "header_id": "section",
                "name": "Section",
                "model_id": "metadata.section",
                "class": "format",
                "type": "text"
              },
              {
                "header_id": "byline",
                "name": "Byline",
                "model_id": "metadata.authors[0]",
                "class": "author",
                "type": "text"
              },
              {
                "header_id": "lastupdae",
                "name": "Last Updated On",
                "model_id": "lastModifiedDate",
                "class": "lastupdae",
                "type": "date",
                "sortDataBy": 1,
                "sortByValue": "lastModifiedDate"
              },
              {
                "header_id": "lastModifiedBy",
                "name": "Updated By",
                "model_id": "lastModifiedByUserName",
                "class": "lastModifiedBy",
                "type": "text"
              }
            ],
            "filters": [
              {
                "filter_id": "byline",
                "name": "Byline",
                "facet_name_meta": "authorNames",
                "facet_name": "metadata.authors",
                "type": "api_filter"
              },
              {
                "filter_id": "createdon",
                "name": "Created On",
                "facet_name_meta": "createdDate",
                "facet_name": "createdDate",
                "type": "daterange"
              },
              {
                "filter_id": "status",
                "name": "Status",
                "facet_name_meta": "statuses",
                "facet_name": "metadata.status",
                "type": "checkbox"
              },
              {
                "filter_id": "social",
                "name": "Social",
                "facet_name_meta": "social",
                "facet_name": "social",
                "type": "social",
                "social": "social"
              },
              {
                "filter_id": "section",
                "name": "Section",
                "facet_name_meta": "sections",
                "facet_name": "metadata.section",
                "type": "checkbox"
              },
              {
                "filter_id": "lastModifiedByUserName",
                "name": "Created by",
                "facet_name_meta": "createdBy",
                "facet_name": "createdBy",
                "type": "api_filter"
              },
              {
                "filter_id": "agency",
                "name": "Agency",
                "facet_name_meta": "agencies",
                "facet_name": "metadata.agency",
                "type": "checkbox"
              }
            ]
          },
          {
            "view_id": "all_stories",
            "list_router": "/dash/story",
            "name": "All Stories",
            "socketCodes": [1,2,7],
            "apiEndPoints": [
              {
                "api_id": "all_story",
                "name": "All Stories",
                "url": "/api/cms/stories"
              },
              {
                "api_id": "search_story",
                "name": "Stories",
                "url": "/api/cms/search/story"
              },
              {
                "api_id": "search_inPage",
                "name": "Stories",
                "url": "/api/cms/search/all"
              },
              {
                "api_id": "dashboard_meta",
                "name": "Dashboard Meta",
                "url": "/api/cms/dashboard/meta"
              },
              {
                "api_id": "story_suggestions",
                "name": "Dashboard Story Suggestions",
                "url": "/api/cms/story/suggestions"
              },
              {
                "api_id": "get_story_byids",
                "url": "/api/cms/story/get-all-by-ids/"
              },
              {
                "api_id": "unlock",
                "url": "/api/cms/unlock/article"
              }
            ],
            "headers": [
              {
                "header_id": "headline",
                "name": "Headline",
                "model_id": "title",
                "class": "headline spImg",
                "type": "text",
                "conditionOn": 1
              },
              {
                "header_id": "format",
                "name": "Type",
                "model_id": "type",
                "class": "format",
                "type": "text",
                "showIcon": true

              },
              {
                "header_id": "status",
                "name": "Status",
                "model_id": "metadata.status",
                "class": "status",
                "type": "status",
                "colorCondition": true
              },
              {
                "header_id": "section",
                "name": "Section",
                "model_id": "metadata.section",
                "class": "format",
                "type": "text"
              },
              {
                "header_id": "byline",
                "name": "Byline",
                "model_id": "metadata.authors[0]",
                "class": "author",
                "type": "text"
              },
              {
                "header_id": "lastupdae",
                "name": "Last Updated On",
                "model_id": "lastModifiedDate",
                "class": "lastupdae",
                "type": "date",
                "sortDataBy": 1,
                "sortByValue": "lastModifiedDate"
              },
              {
                "header_id": "lastModifiedBy",
                "name": "Updated By",
                "model_id": "lastModifiedByUserName",
                "class": "lastModifiedBy",
                "type": "text"
              }
            ],
            "filters": [
              {
                "filter_id": "domain",
                "name": "Domain",
                "facet_name_meta": "flags",
                "facet_name": "domainId",
                "type": "domainList"
              },
              {
                "filter_id": "byline",
                "name": "Byline",
                "facet_name_meta": "authorNames",
                "facet_name": "metadata.authors",
                "type": "api_filter"
              },
              {
                "filter_id": "createdon",
                "name": "Created On",
                "facet_name_meta": "createdDate",
                "facet_name": "createdDate",
                "type": "daterange"
              },
              {
                "filter_id": "format",
                "name": "Type",
                "facet_name_meta": "types",
                "facet_name": "type",
                "type": "checkbox"
              },
              {
                "filter_id": "status",
                "name": "Status",
                "facet_name_meta": "statuses",
                "facet_name": "metadata.status",
                "type": "checkbox"
              },
              {
                "filter_id": "social",
                "name": "Social",
                "facet_name_meta": "social",
                "facet_name": "social",
                "type": "social",
                "social": "social"

                // "filter_id": "updated",
                // "name": "Updated",
                // "facet_name_meta": "lastModifiedDate",
                // "facet_name": "lastModifiedDate",
                // "type": "daterange"
              },
              {
                "filter_id": "section",
                "name": "Section",
                "facet_name_meta": "sections",
                "facet_name": "metadata.section",
                "type": "checkbox"
              },

              {
                "filter_id": "lastModifiedByUserName",
                "name": "Created by",
                "facet_name_meta": "createdBy",
                "facet_name": "createdBy",
                "type": "api_filter"
              },
              {
                "filter_id": "agency",
                "name": "Agency",
                "facet_name_meta": "agencies",
                "facet_name": "metadata.agency",
                "type": "checkbox"
              },
              {
                "filter_id": "flags",
                "name": "Category",
                "facet_name_meta": "flags",
                "facet_name": "metadata",
                "type": "radio",
                "social": "social"
              }
            ]
          },
          {
            "view_id": "my_workspace",
            "name": "My Workspace",
            "list_router": "/dash/story",
            "subPages": [],
            "apiEndPoints": [
              {
                "api_id": "workspace",
                "name": "My Workspace",
                "url": "/api/cms/stories"
              },
              {
                "api_id": "search_myworkspace",
                "name": "My search Workspace",
                "url": "/api/cms/stories"
              },
              {
                "api_id": "dashboard_meta",
                "name": "Dashboard Meta",
                "url": "/api/cms/workspace/meta"
              },
              {
                "api_id": "myworkspace_suggestions",
                "name": "Dashboard Story Suggestions",
                "url": "/api/cms/story/suggestions"
              }
            ],
            "headers": [
              {
                "header_id": "headline",
                "name": "Headline",
                "model_id": "title",
                "class": "headline spImg",
                "type": "text",
                "conditionOn": 1,

              },
              {
                "header_id": "format",
                "name": "Type",
                "model_id": "type",
                "class": "format",
                "type": "text",
                "showIcon": true

              },
              {
                "header_id": "status",
                "name": "Status",
                "model_id": "metadata.status",
                "class": "status",
                "type": "status",
                "colorCondition": true
              },
              {
                "header_id": "section",
                "name": "Section",
                "model_id": "metadata.section",
                "class": "format",
                "type": "text"
              },
              {
                "header_id": "byline",
                "name": "Byline",
                "model_id": "metadata.authors[0]",
                "class": "author",
                "type": "text"
              },
              {
                "header_id": "lastupdae",
                "name": "Last Updated On",
                "model_id": "lastModifiedDate",
                "class": "lastupdae",
                "type": "date",
                "sortDataBy": 1,
                "sortByValue": "lastModifiedDate"
              },
              {
                "header_id": "lastModifiedBy",
                "name": "Updated By",
                "model_id": "lastModifiedByUserName",
                "class": "lastModifiedBy",
                "type": "text"
              }
            ],
            "filters": [
              {
                "filter_id": "byline",
                "name": "Byline",
                "facet_name_meta": "authorNames",
                "facet_name": "metadata.authors",
                "type": "api_filter"
              },
              {
                "filter_id": "updated",
                "name": "Updated",
                "facet_name_meta": "lastModifiedDate",
                "facet_name": "lastModifiedDate",
                "type": "daterange"
              }
              ,
              {
                "filter_id": "section",
                "name": "Section",
                "facet_name_meta": "sections",
                "facet_name": "metadata.section",
                "type": "checkbox"
              },
              {
                "filter_id": "format",
                "name": "Type",
                "facet_name_meta": "types",
                "facet_name": "type",
                "type": "checkbox"
              }
            ]

          }
        ]
      },
      {
        "view_id": "pages",
        "name": "Pages",
        "list_router": "/dash/page",
        "socketCodes": [5, 6],
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "all_pages",
            "name": "All Pages",
            "url": "/api/cms/page/search"
          },
          {
            "api_id": "search_pages",
            "name": "Feeds",
            "url": "/api/cms/page/search"
          },
          {
            "api_id": "one_page",
            "name": "One Page",
            "url": "/api/cms/page"
          },
          {
            "api_id": "pages_meta",
            "name": "Pages Meta",
            "url": "/api/cms/page/meta"
          },
          {
            "api_id": "save_page",
            "name": "Pages save",
            "url": "/api/cms/page/"
          },
          {
            "api_id": "get_page",
            "name": "Page Get",
            "url": "/api/cms/page"
          },
          {
            "api_id": "delete_articlefrompage",
            "name": "Article Delete",
            "url": "/api/cms/page/remove/article"
          },
          {
            "api_id": "page_lock_acquire",
            "name": "Page Lock Acquire",
            "url": "/api/cms/lock/acquire/page"
           // /api/cms/lock/acquire/page
          },
          {
            "api_id": "page_lock_release",
            "name": "Page Lock Release",
            "url": "/api/cms/lock/release/page"
          },
          {
            "api_id": "page_unlock",
            "name": "Page Lock Release",
            "url": "/api/cms/unlock/page"
          },
          {
            "api_id": "page_versions",
            "name": "Page Versions",
            "url": "/api/cms/story/versions"
          },
          {
            "api_id": "page_list",
            "name": "Page List",
            "url": "/api/cms/page/articles/"
          },
          {
            "api_id": "page_putArticle",
            "name": "Page Put Article",
            "url": "/api/cms/page/add/article/"
          }

        ],
        "headers": [
          {
            "header_id": "name",
            "name": "Name",
            "model_id": "name",
            "class": "name",
            "type": "text",
            "lockpage": 1,
            "showIcon": false
          },
          {
            "header_id": "URL",
            "name": "URL",
            "model_id": "url",
            "class": "url",
            "type": "url",
            "showIcon": false
          },
          {
            "header_id": "lastModifiedDate",
            "name": "Last Updated On",
            "sortDataBy": 1,
            "sortByValue": "lastModifiedDate",
            "model_id": "lastModifiedDate",
            "class": "lastModifiedDate",
            "type": "date"
          },
          {
            "header_id": "lastModifiedBy",
            "name": "Updated By",
            "model_id": "lastModifiedByUserName",
            "class": "section",
            "type": "text"
          },
          {
            "header_id": "type",
            "name": "Type",
            "model_id": "pageType",
            "class": "type",
            "type": "text"
          }
        ],
        "filters": [
          {
            "filter_id": "created",
            "name": "Created on",
            "facet_name_meta": "creationDate",
            "facet_name": "creationDate",
            "type": "daterange"
          },
          {
            "filter_id": "published",
            "name": "Published",
            "facet_name_meta": "lastPublishedDate",
            "facet_name": "lastPublishedDate",
            "type": "daterange"
          },
          {
            "filter_id": "type",
            "name": "Type",
            "facet_name_meta": "types",
            "facet_name": "pageType",
            "type": "checkbox"
          },
          {
            "filter_id": "status",
            "name": "Page Status",
            "facet_name_meta": "statuses",
            "facet_name": "status",
            "type": "checkbox"
          }
        ]
      },
      {
        "view_id": "wires",
        "name": "Feeds",
        "socketCodes": [3, 4],
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "all_feeds",
            "name": "All Feeds",
            "url": "/api/cms/wires"
          },
          {
            "api_id": "search_feeds",
            "name": "Feeds",
            "url": ""
          },
          {
            "api_id": "one_story",
            "name": "One Wire Story",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wires_meta",
            "name": "Wires Meta",
            "url": "/api/cms/wire/meta"
          },
          {
            "api_id": "save_wire",
            "name": "Wires Update",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wire_suggestions",
            "name": "Dashboard Story Suggestions",
            "url": "/api/cms/wire/suggestions"
          }
        ],
        "headers": [
          {
            "header_id": "headline",
            "name": "Headline",
            "model_id": "headline",
            "class": "headline",
            "type": "text"
          },
          {
            "header_id": "agency",
            "name": "Agency",
            "model_id": "agency",
            "class": "agency",
            "type": "text"
          },
          {
            "header_id": "section",
            "name": "Section",
            "model_id": "section",
            "class": "section",
            "type": "text"
          },
          {
            "header_id": "receivedAt",
            "name": "Received At",
            "sortDataBy": 1,
            "sortByValue": "timestamp",
            "model_id": "timestamp",
            "class": "receivedAt",
            "type": "date"
          }, {
            "header_id": "pickUp",
            "name": "Pick Up",
            "model_id": "pickUp",
            "class": "pickUp",
            "type": "component"
          }
        ],
        "filters": [
          {
            "filter_id": "published",
            "name": "Published",
            "facet_name_meta": "timestamp",
            "facet_name": "timestamp",
            "type": "daterange"
          },
          {
            "filter_id": "agency",
            "name": "Agency",
            "facet_name_meta": "agencyNames",
            "facet_name": "agency",
            "type": "checkbox"
          },
          {
            "filter_id": "section",
            "name": "Section",
            "facet_name_meta": "sections",
            "facet_name": "section",
            "type": "checkbox"
          }
        ]
      },
      {
        "view_id": "print_wires",
        "name": "Feeds",
        "socketCodes": [3, 4],
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "all_feeds",
            "name": "All Feeds",
            "url": "/api/cms/wires"
          },
          {
            "api_id": "search_feeds",
            "name": "Feeds",
            "url": ""
          },
          {
            "api_id": "one_story",
            "name": "One Wire Story",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wires_meta",
            "name": "Wires Meta",
            "url": "/api/cms/wire/mint/meta"
          },
          {
            "api_id": "save_wire",
            "name": "Wires Update",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wire_suggestions",
            "name": "Dashboard Story Suggestions",
            "url": "/api/cms/wire/suggestions"
          }
        ],
        "headers": [
          {
            "header_id": "headline",
            "name": "Headline",
            "model_id": "headline",
            "class": "headline",
            "type": "text"
          },
          {
            "header_id": "issue_date",
            "name": "Issue Date",
            "model_id": "issueDate",
            "class": "agency",
            "type": "date_day"
          },
          {
            "header_id": "section",
            "name": "Section",
            "model_id": "section",
            "class": "section",
            "type": "text"
          },
          {
              'header_id': 'status',
              'name': 'Status',
              'model_id': 'status',
              'class': 'status',
              'type': 'text'
            },
          {
            "header_id": "receivedAt",
            "name": "Received At",
            "sortDataBy": 1,
            "sortByValue": "timestamp",
            "model_id": "timestamp",
            "class": "receivedAt",
            "type": "date"
          }, {
            "header_id": "pickUp",
            "name": "Pick Up",
            "model_id": "pickUp",
            "class": "pickUp",
            "type": "component"
          }
        ],
        "filters": [
          {
            "filter_id": "issued",
            "name": "Issued At",
            "facet_name_meta": "issueDate",
            "facet_name": "issueDate",
            "type": "daterange"
          },
          {
            "filter_id": "received",
            "name": "Received At",
            "facet_name_meta": "timestamp",
            "facet_name": "timestamp",
            "type": "daterange"
          },
          {
            "filter_id": "section",
            "name": "Section",
            "facet_name_meta": "sections",
            "facet_name": "section",
            "type": "checkbox"
          },
          {
            "filter_id": "status",
            "name": "Status",
            "facet_name_meta": "status",
            "facet_name": "status",
            "type": "checkbox"
          }
        ]
      },
      {
        "view_id": "pulse_wires",
        "name": "Feeds",
        "socketCodes": [3, 4],
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "all_feeds",
            "name": "All Feeds",
            "url": "/api/cms/wires"
          },
          {
            "api_id": "search_feeds",
            "name": "Feeds",
            "url": ""
          },
          {
            "api_id": "one_story",
            "name": "One Wire Story",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wires_meta",
            "name": "Wires Meta",
            "url": "/api/cms/wire/meta"
          },
          {
            "api_id": "save_wire",
            "name": "Wires Update",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wire_suggestions",
            "name": "Dashboard Story Suggestions",
            "url": "/api/cms/wire/suggestions"
          }
        ],
        "headers": [
          {
            "header_id": "headline",
            "name": "Headline",
            "model_id": "headline",
            "class": "headline",
            "type": "text"
          },
          {
            "header_id": "agency",
            "name": "Agency",
            "model_id": "agency",
            "class": "agency",
            "type": "text"
          },
          {
            "header_id": "receivedAt",
            "name": "Published On",
            "sortDataBy": 1,
            "sortByValue": "firstPublishedTimestamp",
            "model_id": "firstPublishedTimestamp",
            "class": "receivedAt",
            "type": "date"
          },
          {
            "header_id": "pickURL",
            "name": "URL",
            "model_id": "story[0].content",
            "class": "pickUp",
            "type": "component"
          }
        ],
        "filters": [
          {
            "filter_id": "published",
            "name": "Published",
            "facet_name_meta": "timestamp",
            "facet_name": "timestamp",
            "type": "daterange"
          },
          {
            "filter_id": "agency",
            "name": "Agency",
            "facet_name_meta": "agencyNames",
            "facet_name": "agency",
            "type": "checkbox"
          }
        ]
      },
      {
        "view_id": "photoListing",
        "name": "storyphotoListing",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "photolist",
            "name": "Internal",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "search_photo",
            "name": "My Photo Search",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "photo_meta",
            "name": "Photo Meta",
            "url": "/api/cms/dashboard/meta"
          }
        ],
        "headers": [
          {
            "header_id": "image",
            "name": "Image",
            "model_id": "image.images.90x60",
            "class": "image",
            "type": "image",
            "bythumbnail": 1,
            "sortByValue": "lastModifiedDate"
          },
          {
            "header_id": "caption",
            "name": "Caption",
            "model_id": "image.caption",
            "class": "caption",
            "type": "text"
          },
          {
            "header_id": "createdon",
            "name": "Created on",
            "model_id": "createdDate",
            "class": "createdon",
            "type": "date",
          },
          {
            "header_id": "tags",
            "name": "Tags",
            "model_id": "metadata.tags",
            "class": "tags",
            "type": "list"
          },
          {
            "header_id": "action",
            "name": "Action",
            "model_id": "action",
            "class": "action",
            "type": "action"
          }
        ],
        "filters": [
          {
            "filter_id": "created",
            "name": "Created At",
            "facet_name_meta": "createdDate",
            "facet_name": "createdDate",
            "type": "daterange"
          },
          {
            "filter_id": "byline",
            "name": "Byline",
            "facet_name_meta": "authorNames",
            "facet_name": "metadata.authors",
            "type": "api_filter"
          }
        ]
      },
      {
        "view_id": "slidePhotoListing",
        "name": "slidePhotoListing",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "photolist",
            "name": "Internal",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "search_photo",
            "name": "My Photo Search",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "photo_meta",
            "name": "Photo Meta",
            "url": "/api/cms/dashboard/meta"
          }
        ],
        "headers": [
          {
            "header_id": "image",
            "name": "Image",
            "model_id": "slide",
            "class": "image",
            "type": "image",
            "bythumbnail": 1,
            "sortByValue": "lastModifiedDate",
            "byField":"type"
          },
          {
            "header_id": "caption",
            "name": "Caption",
            "model_id": "image.caption",
            "class": "caption",
            "type": "text"
          },
          {
            "header_id": "createdon",
            "name": "Created on",
            "model_id": "createdDate",
            "class": "createdon",
            "type": "date",
          },
          {
            "header_id": "tags",
            "name": "Tags",
            "model_id": "metadata.tags",
            "class": "tags",
            "type": "list"
          },
          {
            "header_id": "action",
            "name": "Action",
            "model_id": "action",
            "class": "action",
            "type": "action"
          }
        ],
        "filters": [
          {
            "filter_id": "created",
            "name": "Created At",
            "facet_name_meta": "createdDate",
            "facet_name": "createdDate",
            "type": "daterange"
          },
          {
            "filter_id": "byline",
            "name": "Byline",
            "facet_name_meta": "authorNames",
            "facet_name": "metadata.authors",
            "type": "api_filter"
          }
        ]
      },
      {
        "view_id": "wirephotoListing",
        "name": "wirephotoListing",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "wirephotolist",
            "name": "Internal",
            "url": "/api/cms/wires/images"
          },
          {
            "api_id": "wiresearch_photo",
            "name": "wire Photo Search",
            "url": "/api/cms/wires/images"
          },
          {
            "api_id": "wirephoto_meta",
            "name": "wire Photo Meta",
            "url": "/api/cms/wire/meta"
          }
        ],
        "headers": [
          {
            "header_id": "image",
            "name": "Image",
            "model_id": "thumbnailImageName",
            "class": "image",
            "type": "image",
            "bywirethumbnail": 1
          },
          {
            "header_id": "caption",
            "name": "Caption",
            "model_id": "caption",
            "class": "caption",
            "type": "text"
          },
          {
            "header_id": "createdon",
            "name": "Created on",
            "model_id": "firstPublishedDate",
            "class": "createdon",
            "type": "date",
            "sortDataBy": 1,
            "sortByValue": "timestamp"
          },
          {
            "header_id": "tags",
            "name": "Tags",
            "model_id": "keyword",
            "class": "tags",
            "type": "list"
          },
          {
            "header_id": "action",
            "name": "Action",
            "model_id": "action",
            "class": "action",
            "type": "action"
          }
        ],
        "filters": [
          {
            "filter_id": "created",
            "name": "Received At",
            "facet_name_meta": "timestamp",
            "facet_name": "timestamp",
            "type": "daterange"
          },
          {
            "filter_id": "author",
            "name": "Agency",
            "facet_name_meta": "agencyNames",
            "facet_name": "agency",
            "type": "checkbox"
          }
        ]
      },
      {
        "view_id": "pixabayListing",
        "name": "pixabayListing",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "pixabaylist",
            "name": "Internal",
            "url": "/api/cms/pixabay/images"
          },
          {
            "api_id": "pixabaylist_search",
            "name": "Pixabay Photo Search",
            "url": "/api/cms/pixabay/images"
          },
          {
            "api_id": "pixabay_photo_meta",
            "name": "pixabay Photo Meta",
            "url": "/api/cms/pixabay/meta"
          }
        ],
      },
      {
        "view_id": "mobile91Listing",
        "name": "mobile91Listing",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "mobile91list",
            "name": "Internal",
            "url": "/api/cms/tech/images"
          },
          {
            "api_id": "mobile91",
            "name": "wire Photo Search",
            "url": "/api/cms/tech/images"
          },
          {
            "api_id": "mobile91_meta",
            "name": "wire Photo Meta",
            "url": "/api/cms/wire/meta"
          }
        ],
        "headers": [
          {
            "header_id": "image",
            "name": "Image",
            "model_id": "thumbnailImageName",
            "class": "image",
            "type": "image",
            "bywirethumbnail": 1
          },
          {
            "header_id": "caption",
            "name": "Caption",
            "model_id": "caption",
            "class": "caption",
            "type": "text"
          },
          {
            "header_id": "createdon",
            "name": "Created on",
            "model_id": "firstPublishedDate",
            "class": "createdon",
            "type": "date",
            "sortDataBy": 1,
            "sortByValue": "timestamp"
          },
          {
            "header_id": "tags",
            "name": "Tags",
            "model_id": "keyword",
            "class": "tags",
            "type": "list"
          },
          {
            "header_id": "action",
            "name": "Action",
            "model_id": "action",
            "class": "action",
            "type": "action"
          }
        ]
      },
      {
        "view_id": "all_related_stories",
        "name": "All Stories",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "all_story",
            "name": "All Stories",
            "url": "/api/cms/stories"
          },
          {
            "api_id": "search_story",
            "name": "Stories",
            "url": "/api/cms/search/story"
          },
          {
            "api_id": "dashboard_meta",
            "name": "Dashboard Meta",
            "url": "/api/cms/dashboard/meta"
          },
          {
            "api_id": "story_suggestions",
            "name": "Dashboard Story Suggestions",
            "url": "/api/cms/story/suggestions"
          },
          {

            "api_id": "domain_mapping",
            "name": "Domain Mapping",
            "url": "/api/public/domain/all"
          }
        ],
        "headers": [
          {
            "header_id": "headline",
            "name": "Title",
            "model_id": "title",
            "class": "headline",
            "type": "text",
            "conditionOn": true
          },
          {
            "header_id": "format",
            "name": "Type",
            "model_id": "type",
            "class": "format",
            "type": "text",
            "showIcon": true

          },
          {
            "header_id": "domain",
            "name": "Domain",
            "model_id": "domainId",
            "class": "domain",
            "type": "mapping",
            "mapping_id": "domain",
            "showIcon": false
          },
          {
            "header_id": "section",
            "name": "Section",
            "model_id": "metadata.section",
            "class": "format",
            "type": "text",
            "showIcon": false
          },
          {
            "header_id": "byline",
            "name": "Byline",
            "model_id": "metadata.authors[0]",
            "class": "author",
            "type": "text",
            "showIcon": false
          },
          {
            "header_id": "lastupdatedate",
            "name": "Last Updated On",
            "model_id": "lastModifiedDate",
            "class": "publishedat",
            "type": "date",
            "sortDataBy": 1,
            "sortByValue": "lastModifiedDate"
          },
          {
            "header_id": "selector",
            "name": "Actions",
            "model_id": "",
            "class": "actions",
            "type": "action"
          }
        ],
        "filters": [
          {
            "filter_id": "byline",
            "name": "Byline",
            "facet_name_meta": "authorNames",
            "facet_name": "metadata.authors",
            "type": "api_filter"
          },
          {
            "filter_id": "updated",
            "name": "Updated",
            "facet_name_meta": "lastModifiedDate",
            "facet_name": "lastModifiedDate",
            "type": "daterange"
          }
          ,
          {
            "filter_id": "section",
            "name": "Section",
            "facet_name_meta": "sections",
            "facet_name": "metadata.section",
            "type": "checkbox"
          }
          ,
          {
            "filter_id": "format",
            "name": "Type",
            "facet_name_meta": "types",
            "facet_name": "type",
            "type": "checkbox"
          }
          ,
          {
            "filter_id": "location",
            "name": "City",
            "facet_name_meta": "location",
            "facet_name": "metadata.location",
            "type": "checkbox"
          }
        ]
      },
      {
        "view_id": "all_related_stories_embed",
        "name": "All Stories",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "all_story",
            "name": "All Stories",
            "url": "/cms/affiliate/getItems"
          },
          {
            "api_id": "search_story",
            "name": "Stories",
            "url": "/api/cms/search/story"
          },
          {
            "api_id": "dashboard_meta",
            "name": "Dashboard Meta",
            "url": "/api/cms/dashboard/meta"
          },
          {
            "api_id": "story_suggestions",
            "name": "Dashboard Story Suggestions",
            "url": "/cms/affiliate/getItems"
          },
          {

            "api_id": "domain_mapping_embed",
            "name": "Domain Mapping",
            "url": "/api/public/domain/all"
          }
        ],
        "headers": [

          {
            "header_id": "Image",
            "name": "Image",
            "model_id": "image",
            "class": "image",
            "type": "image",
            "conditionOn": true
          },
          {
            "header_id": "Title",
            "name": "Product Name",
            "model_id": "title",
            "class": "title",
            "type": "title",
            "conditionOn": true
          },
          {
            "header_id": "Price",
            "name": "Price",
            "model_id": "price",
            "class": "price",
            "type": "price",
            "conditionOn": true
          },

          {
            "header_id": "selector",
            "name": "Actions",
            "model_id": "",
            "class": "actions",
            "type": "action"
          }
        ],
        "filters": [ ]
      },
      {
        "view_id": "thumbnailListing",
        "name": "storythumbnailListing",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "thumbnaillist",
            "name": "Internal",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "search_thumbnail",
            "name": "My Photo Search",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "thumbnail_meta",
            "name": "Thumbnail Meta",
            "url": "/api/cms/dashboard/meta"
          }
        ],
        "headers": [
          {
            "header_id": "image",
            "name": "Image",
            "model_id": "image.images.90x60",
            "class": "image",
            "type": "image",
            "bythumbnail": 1,
            "sortByValue": "lastModifiedDate"
          },
          {
            "header_id": "caption",
            "name": "Caption",
            "model_id": "image.caption",
            "class": "caption",
            "type": "text"
          },
          {
            "header_id": "createdon",
            "name": "Created on",
            "model_id": "createdDate",
            "class": "createdon",
            "type": "date",

          },
          {
            "header_id": "tags",
            "name": "Tags",
            "model_id": "metadata.tags",
            "class": "tags",
            "type": "list"
          },
          {
            "header_id": "action",
            "name": "Action",
            "model_id": "action",
            "class": "action",
            "type": "action"
          }
        ],
        "filters": [
          {
            "filter_id": "byline",
            "name": "Byline",
            "facet_name_meta": "authorNames",
            "facet_name": "metadata.authors",
            "type": "api_filter"
          }
        ]
      },
      {
        "view_id": "left_menu",
        "name": "Left Menu",
        "apiEndPoints": [],
        "buttons": [
          {
            "name": "Dashboard",
            "router_link": "./workspace",
            "class": "dashboard",
            "alternateClass": "icon-dashboard-active",
            "active": 1
          },
          {
            "name": "All Elements",
            "router_link": "./elements",
            "class": "allCards",
            "alternateClass": "icon-cards",
            "active": 1
          },
          {
            "name": "Pages",
            "router_link": "./pages",
            "class": "pages",
            "alternateClass": "icon-pages",
            "active": 1
          },
          {
            "name": "Feeds",
            "router_link": "./wire",
            "class": "feeds",
            "id":"feedsLink",
            "alternateClass": "icon-feeds",
            "active": 1
          },
          {
            "name": "Videos",
            "router_link": "./videos",
            "class": "videos",
            "alternateClass": "icon-video",
            "active": 1
          },
          {
            "name": "Users",
            "router_link": "./users",
            "class": "users",
            "alternateClass": "icon-user-management",
            "active": 1
          }
        ]
      },
      {
        "view_id": "ht_digital_wires",
        "name": "Feeds",
        "socketCodes": [3, 4],
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "all_feeds",
            "name": "All Feeds",
            "url": "/api/cms/wires"
          },
          {
            "api_id": "search_feeds",
            "name": "Feeds",
            "url": "/api/cms/wires"
          },
          {
            "api_id": "one_story",
            "name": "One Wire Story",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wires_meta",
            "name": "Wires Meta",
            "url": "/api/cms/wire/meta"
          },
          {
            "api_id": "save_wire",
            "name": "Wires Update",
            "url": "/api/cms/wire"
          },
          {
            "api_id": "wire_suggestions",
            "name": "Dashboard Story Suggestions",
            "url": "/api/cms/wire/suggestions"
          }
        ],
        "headers": [
          {
            "header_id": "headline",
            "name": "Headline",
            "model_id": "headline",
            "class": "headline",
            "type": "text"
          },
          {
            "header_id": "agency",
            "name": "Agency",
            "model_id": "agency",
            "class": "agency",
            "type": "text"
          },
          {
            "header_id": "section",
            "name": "Section",
            "model_id": "section",
            "class": "section",
            "type": "text"
          },
          {
            "header_id": "receivedAt",
            "name": "Received At",
            "sortDataBy": 1,
            "sortByValue": "timestamp",
            "model_id": "timestamp",
            "class": "receivedAt",
            "type": "date"
          },
          {
            "header_id": "pickUp",
            "name": "Pick Up",
            "model_id": "pickUp",
            "class": "pickUp",
            "type": "component"
          }
        ],
        "filters": [
          {
            "filter_id": "published",
            "name": "Published",
            "facet_name_meta": "timestamp",
            "facet_name": "timestamp",
            "type": "daterange"
          },
          {
            "filter_id": "agency",
            "name": "Agency",
            "facet_name_meta": "agencyNames",
            "facet_name": "agency",
            "type": "checkbox"
          },
          {
            "filter_id": "section",
            "name": "Section",
            "facet_name_meta": "sections",
            "facet_name": "section",
            "type": "checkbox"
          }
        ]
      },
      {
        "view_id": "elementheader",
        "name": "Header",
        "apiEndPoints": [],
        "buttons": [
          {
            "name": "Create Element",

            "button_link": "",
            "type": "route",
            "class": "createCard",
            "active": 1,
            "id": "createElementButton",
            "options": [
              {
                "name": "Create collection",
                "router_link": "",
                "button_link": "/dash/element/new?type=collection",
                "type": "button",
                "elementType": "collection",
                "id": "createCollectionButton"
              },
              {
                "name": "Create Embed",
                "router_link": "",
                "button_link": "/dash/element/new?type=embed",
                "type": "button",
                "elementType": "embed",
                "id": "createEmbedButton"
              },
              {
                "name": "Create JSON Embed",
                "router_link": "",
                "button_link": "/dash/element/new?type=jsonfeed",
                "type": "button",
                "elementType": "jsonfeed",
                "id": "createJsonEmbedButton"
              },
              {
                "name": "Create Communities",
                "router_link": "",
                "button_link": "/dash/element/new?type=communities",
                "type": "button",
                "elementType": "communities",
                "id": "createCommunitiesButton"
              },
              {
                "name": "Create Input Form",
                "router_link": "",
                "button_link": "/dash/element/new?type=toptrends",
                "type": "button",
                "elementType": "toptrends",
                "id": "createInputFormButton"
              },
              {
                "name": "Create a Banner",
                "router_link": "",
                "button_link": "/dash/element/new?type=banner",
                "type": "button",
                "elementType": "banner"
              },
              {
                "name": "Create Chart",
                "router_link": "",
                "button_link": "/dash/element/new?type=chart",
                "type": "button",
                "elementType": "chart",
                "id": "createChartButton"
              },
              {
                "name": "Create Table",
                "router_link": "",
                "button_link": "/dash/element/new?type=table",
                "type": "button",
                "elementType": "table",
                "id": "createTableButton"
              }

            ]
          }]
      },
      {
        "view_id": "education",
        "name": "Header",
        "apiEndPoints": [],
        "buttons": [
          {
            "name": "Create",
            "button_link": "",
            "type": "route",
            "class": "createCard",
            "active": 1,
            "options": [
              {
                "name": "College",
                "router_link": "",
                "button_link": "/dash/education/addcollege/new",
                "type": "button",
                "elementType": "education"
              },
              {
                "name": "COURSE",
                "router_link": "/dash/education/addcourse",
                "button_link": "",
                "type": "route",
                "pageType": "COURSE"
              },
              {
                "name": "Entrance Exam",
                "router_link": "/dash/education/addentranceexam",
                "button_link": "",
                "type": "route",
                "pageType": "COURSE"
              }
            ]
          }]
      },
      {
        "view_id": "entertainment",
        "name": "Header",
        "apiEndPoints": [],
        "buttons": [
          {
            "name": "Create",
            "button_link": "",
            "type": "route",
            "class": "createCard",
            "active": 1,
            "options": [
              {
                "name": "Celebrity",
                "router_link": "",
                "button_link": "/dash/entertainment/addcelebrity/new",
                "type": "button",
                "elementType": "entertainment"
              },
              {
                "name": "Movie",
                "router_link": "",
                "button_link": "/dash/entertainment/addmovie/new",
                "type": "button",
                "elementType": "entertainment"
              },
              {
                "name": "TV show",
                "router_link": "",
                "button_link": "/dash/entertainment/addtvShow/new",
                "type": "button",
                "elementType": "entertainment"
              }
            ]
          }]
      },
      {
        "view_id": "stocks",
        "name": "Header",
        "apiEndPoints": [],
        "buttons": [
          {
            "name": "Create",
            "button_link": "",
            "type": "route",
            "class": "createCard",
            "active": 1,
            "options": [
              {
                "name": "STOCK",
                "router_link": "/dash/misc/stock/create-stock",
                "button_link": "",
                "type": "route",
                "pageType": "STOCK"
              },
            ]
          }]
      },
      {
        "view_id": "storyheader",
        "name": "Header",
        "apiEndPoints": [],
        "buttons": [
          {
            "name": "Create a Card",
            "router_link": "",
            "button_link": "",
            "type": "route",
            "class": "createCard",
            "active": 0
          },
          {
            "name": "Create a Story",
            "router_link": "",
            "button_link": "",
            "id":"createStoryButton",
            "type": "button",
            "class": "createStory",
            "active": 1,
            "options": [

              {
                "name": "Standard",
                "router_link": "",
                "button_link": "/dash/story/new?type=story",
                "type": "button",
                "storyType": "story",
                "id":"selectStory"
              },
              {
                "name": "Standard (breaking)",
                "router_link": "",
                "button_link": "/dash/story/new?type=story&breaking=true",
                "type": "button",
                "storyType": "story",
                "id":"selectStory"
              },
              {
                "name": "Photo Gallery",
                "router_link": "",
                "button_link": "/dash/story/new?type=gallery",
                "type": "button",
                "storyType": "gallery",
                "id":"selectPhotoGallery"
              },
              {
                "name": "Infographic",
                "router_link": "",
                "button_link": "/dash/story/new?type=infographic",
                "type": "button",
                "storyType": "infographic",
                "id":"infographicPhotoGallery"
              },
              {
                "name": "Photo Story",
                "router_link": "",
                "button_link": "/dash/story/new?type=photostory",
                "type": "button",
                "storyType": "photostory",
                "id":"selectPhotoStory"
              },
              {
                "name": "Media Gallery",
                "router_link": "",
                "button_link": "/dash/story/new?type=mediagallery",
                "type": "button",
                "storyType": "mediagallery",
                "id":"selectMediaGallery"
              },
              {
                "name": "Live Blog",
                "router_link": "",
                "button_link": "/dash/story/new?type=liveblog",
                "type": "button",
                "storyType": "liveblog",
                "id":"selectLiveBlog"
              },
              {
                "name": "Listicle",
                "router_link": "",
                "button_link": "/dash/story/new?type=listicle",
                "type": "button",
                "storyType": "listicle",
                "id":"selectListicle"
              },
              {
                "name": "Video",
                "router_link": "",
                "button_link": "/dash/story/new?type=video",
                "type": "button",
                "storyType": "video",
                "id":"selectVideoStory"
              },
              {
                "name": "Highlights",
                "router_link": "",
                "button_link": "/dash/story/new?type=highlights",
                "type": "button",
                "storyType": "highlights",
                "id":"selectHighlights"
              },
              {
                "name": "Mint Lite",
                "router_link": "",
                "button_link": "/dash/story/new?type=mintlite",
                "type": "button",
                "storyType": "mintlite"
              }, {
                "name": "Web story",
                "router_link": "",
                "button_link": "/dash/story/new?type=web-story",
                "type": "button",
                "storyType": "web-story"
              },
              {
                "name": "Deadlink",
                "router_link": "",
                "button_link": "/dash/story/new?type=deadlink",
                "type": "button",
                "storyType": "deadlink",
                "id":"selectDeadlinkStory"
              }

            ]
          }
        ]
      },{
        "view_id": "pageheader",
        "name": "Page Header",
        "apiEndPoints": [],
        "buttons": [
          {
            "name": "Create a Card",
            "router_link": "",
            "button_link": "",
            "type": "route",
            "class": "createCard",
            "active": 0
          },
          {
            "name": "Manage Navs",
            "button_link": "",
            "type": "",
            "class": "createStory",
            "active": 1,
            "options": [
              {
                "name": "Header",
                "router_link": "/dash/nav-manager/topnav",
                "button_link": "",
                "type": "route"
              },
              {
                "name": "Footer",
                "router_link": "/dash/footer-manager/topnav",
                "button_link": "",
                "type": "route"
              }
            ]
          },
          {
            "name": "Create a Page",
            "button_link": "",
            "type": "route",
            "class": "createStory",
            "id": "createPageButton",
            "active": 1,
            "options": [
              {
                "name": "PRIMARY",
                "router_link": "/dash/page/new/PRIMARY",
                "button_link": "",
                "type": "route",
                "pageType": "PRIMARY"
              },
              {
                "name": "TOPIC",
                "router_link": "/dash/page/new/TOPIC",
                "button_link": "",
                "type": "route",
                "pageType": "TOPIC"
              },
              {
                "name": "SECTION",
                "router_link": "/dash/page/new/SECTION",
                "button_link": "",
                "type": "route",
                "pageType": "SECTION"
              },
              {
                "name": "BRUNCH",
                "router_link": "/dash/page/new/BRUNCH",
                "button_link": "",
                "type": "route",
                "pageType": "BRUNCH"
              },
              {
                "name": "SERIES",
                "router_link": "/dash/page/new/SERIES",
                "button_link": "",
                "type": "route",
                "pageType": "SERIES"
              },
              {
                "name": "SUBSECTION",
                "router_link": "/dash/page/new/SUBSECTION",
                "button_link": "",
                "type": "route",
                "pageType": "SUBSECTION"
              },
              {
                "name": "COMPANY",
                "router_link": "/dash/page/new/COMPANY",
                "button_link": "",
                "type": "route",
                "pageType": "COMPANY"
              },
              {
                "name": "AGENCY",
                "router_link": "/dash/page/new/AGENCY",
                "button_link": "",
                "type": "route",
                "pageType": "AGENCY"
              },
              {
                "name": "EXTERNAL",
                "router_link": "/dash/pageExternal/new",
                "button_link": "",
                "type": "route",
                "pageType": "EXTERNAL"
              },
              {
                "name": "SUBSECTION-L2",
                "router_link": "/dash/page/new/SUBSECTION_L2",
                "button_link": "",
                "type": "route"
              },
              {
                "name": "APP_SECTION",
                "router_link": "/dash/page/new/APP_SECTION",
                "button_link": "",
                "type": "route",
                "pageType": "APP_SECTION"
              },
              {
                "name": "APP_SUBSECTION",
                "router_link": "/dash/page/new/APP_SUBSECTION",
                "button_link": "",
                "type": "route",
                "pageType": "APP_SUBSECTION"
              }
            ]
          }

        ]
      },
      {
        "view_id": "template",
        "name": "Template",
        "socketCodes": [],
        "list_router": "/dash/element",
        "apiEndPoints": [
          {
            "api_id": "get_element",
            "url": "/api/cms/element"
          },
          {
            "api_id": "all_elements",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "save_element",
            "url": "/api/cms/element"
          },
          {
            "api_id": "search_elements",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "element_meta",
            "url": "/api/cms/element/meta"
          },
          {
            "api_id": "lock_acquire",
            "url": "/api/cms/lock/acquire/article"
          },
          {
            "api_id": "lock_release",
            "url": "/api/cms/lock/release/article"
          },
          {
            "api_id": "unlock",
            "url": "/api/cms/unlock/article"
          },
          {
            "api_id": "update_parent",
            "url": "/api/cms/element/parent"
          }
        ],
        "headers": [
          {
            "header_id": "name",
            "name": "Name",
            "model_id": "title",
            "class": "name",
            "type": "text",
            "lockpage": 1,
            "conditionOn": 1,
            "bytype": 1,
            "showIcon": 1
          },
          {
            "header_id": "status",
            "name": "Status",
            "model_id": "metadata.status",
            "class": "status",
            "type": "text",
            "colorCondition": true
          },
          {
            "header_id": "lastModifiedBy",
            "name": "Updated By",
            "model_id": "lastModifiedByUserName",
            "class": "lastModifiedBy",
            "type": "text"
          },
          {
            "header_id": "lastupdae",
            "name": "Last Updated On",
            "model_id": "lastModifiedDate",
            "class": "lastupdae",
            "type": "date",
            "sortDataBy": 1,
            "sortByValue": "lastModifiedDate"
          },
          {
          "header_id": "type",
          "name": "Type",
          "model_id": "type",
          "class": "lastModifiedBy",
          "type": "text"
          }

        ],
        "filters": [
        {
          "filter_id": "createdon",
          "name": "Created On",
          "facet_name_meta": "createdDate",
          "facet_name": "createdDate",
          "type": "daterange"
        },
        {
          "filter_id": "updated",
          "name": "Updated",
          "facet_name_meta": "lastModifiedDate",
          "facet_name": "lastModifiedDate",
          "type": "daterange"
        },
        {
          "filter_id": "status",
          "name": "Status",
          "facet_name_meta": "statuses",
          "facet_name": "metadata.status",
          "type": "checkbox"
        },
        {
          "filter_id": "type",
          "name": "Type",
          "facet_name_meta": "elementTypes",
          "facet_name": "type",
          "type": "checkbox"
        },
        {
          "filter_id": "lastModifiedByUserName",
          "name": "Created by",
          "facet_name_meta": "createdBy",
          "facet_name": "createdBy",
          "type": "api_filter"
        }
      ],
        "buttons": []
      },
      {
        "view_id": "pick-element",
        "name": "Element",
        "apiEndPoints": [
          {
            "api_id": "get_element",
            "url": "/api/cms/element"
          },
          {
            "api_id": "all_elements",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "save_element",
            "url": "/api/cms/element"
          },
          {
            "api_id": "search_elements",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "element_meta",
            "url": "/api/cms/element/meta"
          },
          {
            "api_id": "lock_acquire",
            "url": "/api/cms/lock/acquire/article"
          },
          {
            "api_id": "lock_release",
            "url": "/api/cms/lock/release/article"
          },
          {
            "api_id": "unlock",
            "url": "/api/cms/unlock/article"
          },
          {
            "api_id": "update_parent",
            "url": "/api/cms/element/parent"
          }
        ],
        "headers": [
          {
            "header_id": "name",
            "name": "Name",
            "model_id": "title",
            "class": "reviewName",
            "type": "text"
          },
          {
            "header_id": "lastModifiedBy",
            "name": "Updated By",
            "model_id": "lastModifiedByUserName",
            "class": "updatedBy",
            "type": "text"
          },
          {
            "header_id": "lastupdae",
            "name": "Last Updated On",
            "model_id": "lastModifiedDate",
            "class": "lastupdatedOn",
            "type": "date",
            "sortDataBy": 1,
            "sortByValue": "lastModifiedDate"
          },
          {
            "header_id": "type",
            "name": "Type",
            "model_id": "type",
            "class": "type",
            "type": "text"
          }

        ],
        "filters": [
        {
          "filter_id": "createdon",
          "name": "Created On",
          "facet_name_meta": "createdDate",
          "facet_name": "createdDate",
          "type": "daterange"
        },
        {
          "filter_id": "updated",
          "name": "Updated",
          "facet_name_meta": "lastModifiedDate",
          "facet_name": "lastModifiedDate",
          "type": "daterange"
        },
        {
          "filter_id": "lastModifiedByUserName",
          "name": "Created by",
          "facet_name_meta": "createdBy",
          "facet_name": "lastModifiedByUserName",
          "type": "api_filter"
        }
      ],
        "buttons": []
      },
      {
        "view_id": "element",
        "name": "Element",
        "socketCodes": [1,8],
        "list_router": "/dash/element",
        "apiEndPoints": [
          {
            "api_id": "get_element",
            "url": "/api/cms/element"
          },
          {
            "api_id": "all_elements",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "save_element",
            "url": "/api/cms/element"
          },
          {
            "api_id": "search_elements",
            "url": "/api/cms/elements"
          },
          {
            "api_id": "element_meta",
            "url": "/api/cms/element/meta"
          },
          {
            "api_id": "lock_acquire",
            "url": "/api/cms/lock/acquire/article"
          },
          {
            "api_id": "lock_release",
            "url": "/api/cms/lock/release/article"
          },
          {
            "api_id": "unlock",
            "url": "/api/cms/unlock/article"
          },
          {
            "api_id": "update_parent",
            "url": "/api/cms/element/parent"
          }
        ],
        "headers": [
          {
            "header_id": "name",
            "name": "Name",
            "model_id": "title",
            "class": "name",
            "type": "text",
            "lockpage": 1,
            "conditionOn": 1,
            "bytype": 1,
            "showIcon": 1
          },
          {
            "header_id": "status",
            "name": "Status",
            "model_id": "metadata.status",
            "class": "status",
            "type": "text",
            "colorCondition": true
          },
          {
            "header_id": "lastModifiedBy",
            "name": "Updated By",
            "model_id": "lastModifiedByUserName",
            "class": "lastModifiedBy",
            "type": "text"
          },
          {
            "header_id": "lastupdae",
            "name": "Last Updated On",
            "model_id": "lastModifiedDate",
            "class": "lastupdae",
            "type": "date",
            "sortDataBy": 1,
            "sortByValue": "lastModifiedDate"
          },
          {
          "header_id": "type",
          "name": "Type",
          "model_id": "type",
          "class": "lastModifiedBy",
          "type": "text"
          }

        ],
        "filters": [
        {
          "filter_id": "createdon",
          "name": "Created On",
          "facet_name_meta": "createdDate",
          "facet_name": "createdDate",
          "type": "daterange"
        },
        {
          "filter_id": "updated",
          "name": "Updated",
          "facet_name_meta": "lastModifiedDate",
          "facet_name": "lastModifiedDate",
          "type": "daterange"
        },
        {
          "filter_id": "type",
          "name": "Type",
          "facet_name_meta": "elementTypes",
          "facet_name": "type",
          "type": "checkbox"
        },
        {
          "filter_id": "status",
          "name": "Status",
          "facet_name_meta": "statuses",
          "facet_name": "metadata.status",
          "type": "checkbox"
        },
        {
          "filter_id": "lastModifiedByUserName",
          "name": "Created by",
          "facet_name_meta": "createdBy",
          "facet_name": "lastModifiedByUserName",
          "type": "api_filter"
        }
      ],
        "buttons": []
      },
      {
        "view_id": "navManager",
        "name": "Nav Manager",
        "list_router": "/dash/page",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "navManagerlist",
            "name": "Get Nav Manager list",
            "url": "/api/cms/page/section/navigation"
          },
          {
            "api_id": "putNavManagerlist",
            "name": "Put Nav Manager list",
            "url": "/api/cms/page/section/navigation"
          },
           {
            "api_id": "L1navManagerlist",
            "name": "Post L1 Manager list",
            "url": "/api/cms/page/level/navigation"
          },
          {
            "api_id": "putL1NavManagerlist",
            "name": "Get Nav Manager list",
            "url": "/api/cms/page/level/navigation"
          },
          {
            "api_id": "l1_nav_lock_acquire",
            "name": "Nav Lock Acquire",
            "url": "/api/cms/lock/acquire/level/navigation"
          },
          {
            "api_id": "l1_nav_lock_release",
            "name": "Nav Lock Release",
            "url": "/api/cms/lock/release/level/navigation"
          },
          {
            "api_id": "l1_nav_unlock",
            "name": "Nav Lock Release",
            "url": "/api/cms/unlock/level/navigation"
          },
          {
            "api_id": "footerManagerlist",
            "name": "Get footer Manager list",
            "url": "/api/cms/page/footer/navigation"
          },
          {
            "api_id": "putfooterManagerlist",
            "name": "Put footer Manager list",
            "url": "/api/cms/page/footer/navigation"
          },
          {
            "api_id": "getTopicManagerlist",
            "name": "Get Nav Manager list",
            "url": "/api/cms/page/topic/navigation"
          },
          {
            "api_id": "putTopicNavManagerlist",
            "name": "Put Nav Manager list",
            "url": "/api/cms/page/topic/navigation"
          },
          {
            "api_id": "all_pages",
            "name": "All Pages",
            "url": "/api/cms/page/search"
          },
          {
            "api_id": "search_pages",
            "name": "Feeds",
            "url": "/api/cms/page/search"
          },
          {
            "api_id": "pages_meta",
            "name": "Pages Meta",
            "url": "/api/cms/page/meta"
          },
          {
            "api_id": "nav_lock_acquire",
            "name": "Nav Lock Acquire",
            "url": "/api/cms/lock/acquire/section/navigation"
          },
          {
            "api_id": "nav_lock_release",
            "name": "Nav Lock Release",
            "url": "/api/cms/lock/release/section/navigation"
          },
          {
            "api_id": "nav_unlock",
            "name": "Nav Lock Release",
            "url": "/api/cms/unlock/section/navigation"
          },
          {
            "api_id": "footer_lock_acquire",
            "name": "Nav Lock Acquire",
            "url": "/api/cms/lock/acquire/footer/navigation"
          },
          {
            "api_id": "footer_lock_release",
            "name": "Nav Lock Release",
            "url": "/api/cms/lock/release/footer/navigation"
          },
          {
            "api_id": "footer_unlock",
            "name": "Nav Lock Release",
            "url": "/api/cms/unlock/footer/navigation"
          }
        ],
        "filters": [
          {
            "filter_id": "type",
            "name": "Type",
            "facet_name_meta": "types",
            "facet_name": "pageType",
            "type": "checkboxNav"
          },
          {
            "filter_id": "published",
            "name": "Published",
            "facet_name_meta": "lastPublishedDate",
            "facet_name": "lastPublishedDate",
            "type": "daterange"
          }
        ]
      },
      {
        "view_id": "header_main",
        "name": "Header",
        "subPages": [],
        "apiEndPoints": [
          {
            "api_id": "browser_flash",
            "url": "/api/cms/notify/browser/flash"
          },
          {
            "api_id": "mobile_flash",
            "url": "/api/cms/notify/mobile/flash"
          },
          {
            "api_id": "webengage_tags",
            "url": "/api/cms/webengage/tags"
          },
          {
            "api_id": "webengage_segments",
            "url": "/api/cms/webengage/segments"
          },
          {
            "api_id": "webengage_notificationtype",
            "url": "/api/cms/webengage/type"
          },
          {
            "api_id": "webengage_applications",
            "url": "/api/cms/webengage/applications"
          },
          {
            "api_id": "webengage_notify",
            "url": "/api/cms/webengage/notify"
          },
          {
            "api_id": "webengage_body",
            "url": "/ht/cms/story"
          },
          {
            "api_id": "webengage_analytics",
            "url": "/api/cms/webengage/analytics"
          },
          {
            "api_id": "moengage_analytics",
            "url": "/api/cms/moengage/analytics"
          },
          {
            "api_id": "get_moengage_segments",
            "url": "/api/cms/moengage/segment/all"
          },
          {
            "api_id": "get_cross_domains",
            "url": "/api/cms/moengage/crossDomain/all"
          },
          {
            "api_id": "create_moengage_segment",
            "url": "/api/cms/moengage/segment"
          },
          {
            "api_id": "send_moengage_notification",
            "url": "/api/cms/moengage/notify"
          }
        ]
      }
    ]
  }
};
